import { atom, useSetRecoilState } from "recoil"
import { EditPrefType } from "../constants/index"
import { Preferito, ServiceDescriptor } from "../models/ServiceDescriptor"
import apiService from "../services/api"
import { linksRequestNumberState, preferitiRequestNumberState } from "./portale"

const editPrefDefault: EditPrefType = {show: false, title: 'Edit Preferito'}
export const editPrefShowAtom = atom({
    key: 'editPrefShowAtom',
    default: editPrefDefault
})

export const useEditPreferito = () => {
    const setEditPrefShow = useSetRecoilState(editPrefShowAtom)
    return (sd?: ServiceDescriptor, preferito?: Preferito, iconName?: string, color?: string, title?: string) => {
        setEditPrefShow({
            show: true,
            appl: sd,
            preferito,
            iconName,
            color,
            title
        })
    }
}

export const useDeletePreferito = () => {
    const setPreferitoRequestNumber = useSetRecoilState(preferitiRequestNumberState)
    const setLinksRequestNumberState = useSetRecoilState(linksRequestNumberState)
    return (pref?: Preferito) => {
        if (pref) {
            // console.log(`Cancellazione del preferito ${pref?.id}`)
            apiService.deletePreferito(pref.id).then((data) => {
                console.log(`Cancellato preferito ${pref?.id} - ${data}`)
                setPreferitoRequestNumber(rn => rn + 1)
                setLinksRequestNumberState(current => current + 1);
            })
        }
    }
}


